import AssignableAssistantsAPI from '../../api/assignableAssistants';

const state = {
  records: {},
  uiFlags: {
    isFetching: false,
  },
};

export const types = {
  // NOTICE: KAPTION-INTEGRATION
  SET_INBOX_ASSIGNABLE_ASSISTANTS_UI_FLAG:
    'SET_INBOX_ASSIGNABLE_ASSISTANTS_UI_FLAG',
  SET_INBOX_ASSIGNABLE_ASSISTANTS: 'SET_INBOX_ASSIGNABLE_ASSISTANTS',
};

export const getters = {
  // NOTICE: KAPTION-INTEGRATION
  getAssignableAssistants: $state => inboxId => {
    const allAssistants = $state.records[inboxId] || [];
    return allAssistants.filter(record => record.confirmed);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  async fetch({ commit }, inboxIds) {
    commit(types.SET_INBOX_ASSIGNABLE_ASSISTANTS_UI_FLAG, { isFetching: true });
    try {
      const {
        data: { payload },
      } = await AssignableAssistantsAPI.get(inboxIds);
      commit(types.SET_INBOX_ASSIGNABLE_ASSISTANTS, {
        inboxId: inboxIds.join(','),
        members: payload,
      });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_INBOX_ASSIGNABLE_ASSISTANTS_UI_FLAG, {
        isFetching: false,
      });
    }
  },
};

export const mutations = {
  [types.SET_INBOX_ASSIGNABLE_ASSISTANTS_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_INBOX_ASSIGNABLE_ASSISTANTS]: ($state, { inboxId, members }) => {
    $state.records = {
      ...$state.records,
      [inboxId]: members,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
